import styled from 'styled-components';

export const HowToWrapper = styled.div`
  background: var(--color-interface-neutral-light);
  border-radius: 8px;
  padding: 24px;
  margin-top: 50px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  border-color: #e8e8e8;
  background: #f8f8f8;
  position: relative;
  overflow: auto;
`;

export const QueryBuilderContainer = styled.main`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  background: #fff;
  color: #14171a;
  font-size: 12px;
  min-width: 950px;
  position: relative;

  button,
  a {
    outline: none;
  }
`;
